
import WeatherApi from './src/WeatherApi'
import UniformConfigApi from './src/UniformConfigApi'

let apis = {
   WeatherApi,
   UniformConfigApi
};

export default apis;